module.exports = __webpack_public_path__ + "static/setting up a turn server-fe8028410829ddbfa9bab622ed9cff7e.png";